export default function({ data, headers }) {
  const blob = new Blob([data], { type: headers['content-type'] });
  return window.URL.createObjectURL(blob);
}
  